import { UpdateUserPreferencesDto, UserPreferencesResponse } from '@shared/core/preferences'
import ms from 'ms'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { PreferencesService } from 'src/services/preferences.service'

export const GET_USER_PREFERENCES_CACHE_KEY = 'get-user-preferences'
export const UPDATE_USER_PREFERENCES_CACHE_KEY = 'update-user-preferences'

export function useUserPreferences(options?: UseQueryOptions<UserPreferencesResponse> & { bypassCache?: boolean }) {
  const handleRetry = useHandleRetry()
  const { bypassCache, ...queryOptions } = options || {}

  return useQuery([GET_USER_PREFERENCES_CACHE_KEY], () => PreferencesService.getPreferences(), {
    staleTime: bypassCache ? 0 : ms('5 minutes'),
    cacheTime: bypassCache ? 0 : undefined,
    retry: handleRetry,
    ...queryOptions,
  })
}

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient()
  return useMutation(
    UPDATE_USER_PREFERENCES_CACHE_KEY,
    (dto: UpdateUserPreferencesDto) => PreferencesService.updatePreferences(dto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_USER_PREFERENCES_CACHE_KEY])
      },
    },
  )
}
